import {updateAnnouncementBanner} from 'features/annoucement_banner/slices/announcement_banner_slice';
import {type AnnouncementBannerUpdateEvent} from 'features/annoucement_banner/types';
import store from 'stores/redux_store';

export const handleAnnouncementBanner = (message: AnnouncementBannerUpdateEvent) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const {text_color, banner_color, allow_dismissal, ...banner} = JSON.parse(message.data.announcement_banner);

    store.dispatch(updateAnnouncementBanner({
        ...banner,
        textColor: text_color,
        bannerColor: banner_color,
        allowDismiss: allow_dismissal,
    }));
};
